<template>
  <div class="story-text-container">
    <p v-for="line in storyLine.lines" :key="line.index" class="story-text-style">{{ line }}</p>

    <section
      v-if="userChoice[4] == 'winFight__Father'"
      class="story-text-style story-button-container"
    >
      <button class="story-btn-style" @click="navigateTo('leave')">Proceed</button>
    </section>

    <section
      v-if="userChoice[4] == 'loseFight__Father'"
      class="story-text-style story-button-container"
    >
      <button class="story-btn-style" @click="navigateTo('stay')">I want to stay</button>
      <button
        class="story-btn-style"
        @click="navigateTo('leaveToFind')"
      >I want to leave and find Councilor Great</button>
    </section>

    <section
      v-if="userChoice[4] == 'clanOne__Father'"
      class="story-text-style story-button-container"
    >
      <button class="story-btn-style" @click="navigateTo('sorrow')">Proceed</button>
    </section>

    <section
      v-if="userChoice[4] == 'clanTwo__Father'"
      class="story-text-style story-button-container"
    >
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>

    <section
      v-if="userChoice[4] == 'clanOne__Mother'"
      class="story-text-style story-button-container"
    >
      <button class="story-btn-style" @click="navigateEnd(true)">END</button>
    </section>

    <section
      v-if="userChoice[4] == 'clanTwo__Mother'"
      class="story-text-style story-button-container"
    >
      <button
        class="story-btn-style"
        @click="navigateTo('notUnite__Clan')"
      >Townspeople don't follow you</button>
      <button
        class="story-btn-style"
        @click="navigateTo('unite__Clan', true, 'Leadership')"
      >Townspeople follow you</button>
    </section>

    <section
      v-if="userChoice[4] == 'loseFight__Mother'"
      class="story-text-style story-button-container"
    >
      <button class="story-btn-style" @click="navigateTo('findFairy')">Proceed</button>
    </section>

    <section
      v-if="userChoice[4] == 'winFight__Mother'"
      class="story-text-style story-button-container"
    >
      <button
        class="story-btn-style"
        @click="navigateTo('notUnite__Fight')"
      >Townspeople don't follow you</button>
      <button
        class="story-btn-style"
        @click="navigateTo('unite__Fight', true, 'Leadership')"
      >Townspeople follow you</button>
    </section>
  </div>
</template>

<script>
export default {
  name: "Story-Six",
  data() {
    return {
      userTrait: this.$store.state.userPersonality,
      userChoice: this.$store.state.userChoices
    };
  },
  computed: {
    storyLine() {
      return this.$store.state.Six[this.userChoice[4]];
    }
  },
  methods: {
    navigateEnd(condition) {
      if (condition) {
        this.$router.push("/story/end");
      }
    },
    navigateTo(choice = "none", isTraitRequired = false, trait = "") {
      let checkAccess, deniedReason;
      if (isTraitRequired) {
        if (this.userTrait.indexOf(trait) > -1) {
          checkAccess = true;
          this.$store.dispatch("updateChoice", choice);
        } else {
          checkAccess = false;
          deniedReason = `You don't have the particular trait: ${trait}`;
        }
        this.$store.commit("setModalDisplay", {
          display: true,
          isGranted: checkAccess,
          deniedReason,
          url: "/story/seven"
        });
      } else {
        this.$store.dispatch("updateChoice", choice);
        this.$store.commit("setModalDisplay", {
          display: true,
          isGranted: true,
          url: "/story/seven"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/css/Scheme.scss";
</style>
